__turbopack_context__.v({
  "block": "ScriptBlock-module__Futf2W__block",
  "body": "ScriptBlock-module__Futf2W__body",
  "filterInput": "ScriptBlock-module__Futf2W__filterInput",
  "list": "ScriptBlock-module__Futf2W__list",
  "text": "ScriptBlock-module__Futf2W__text",
  "title": "ScriptBlock-module__Futf2W__title",
});
